import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
`;
Wrapper.displayName = 'Wrapper';

export const EmptyWrapper = styled.div`
  margin: 0px auto auto auto;
`;
EmptyWrapper.displayName = 'EmptyWrapper';

export const TableContainer = styled.div`
  height: 100%;
  flex: 1 1 0px;
  overflow: hidden;
`;
TableContainer.displayName = 'TableContainer';
